import request from '@/utils/request'

/**
 * 查询员工收藏商品列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回员工收藏商品列表
 */
export function queryStaffCollectedProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/collect.queryStaffCollectedProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加员工收藏商品
 * @param {Object} data 员工收藏商品数据
 * @returns {Promise} 返回操作结果
 */
export function saveStaffCollectedProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/collect.saveStaffCollectedProduct',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除员工收藏商品
 * @param {Object} data 员工收藏商品数据
 * @returns {Promise} 返回操作结果
 */
export function deleteStaffCollectedProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/collect.deleteStaffCollectedProduct',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

